module.exports = __webpack_public_path__ + "static/media/Bear Paw_Outline_2c.2f24778f.svg";